import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LandingLayout from "./LandingLayout";
import api from "../../Environment";
import { fetchTopPostVideosStart } from "../../store/actions/PostAction";

const LandingPage = () => {
  const dispatch = useDispatch();
  const topPostVideos = useSelector((state) => state.post.topPostVideos);

  useEffect(() => {
    dispatch(fetchTopPostVideosStart());
  }, [dispatch]);

  const colors = ["violet", "green", "pink", "blue", "orange", "gold"];

  return (
    <LandingLayout title="Rebel | The Home of Bahamian Creators">
      <section className="hero" id="watch">
        <div className="hero-glow hero-glow-one"></div>
        <div className="hero-glow hero-glow-two"></div>
        <div className="palm palm-one"></div>
        <div className="palm palm-two"></div>

        <div className="hero-copy">
          <p className="eyebrow">Watch local. Support local.</p>
          <h1>
            The Home of <span>Bahamian<br /> Creators</span>
          </h1>
          <p className="hero-text">
            Discover exclusive Bahamian videos, podcasts, music, sports and live
            events — all while supporting the creators you love.
          </p>

          <div className="hero-actions">
            <a className="btn btn-gradient btn-large" href="/signup">
              <span className="play-icon">▶</span> Sign Up
            </a>
            <a className="btn btn-outline btn-large" href="/signin">
              <span className="user-icon">♙</span> Sign In
            </a>
          </div>

          <div className="community-proof">
            <div className="avatar-stack">
              <img src="/assets/creators/creator-1.png" alt="Creator" />
              <img src="/assets/creators/creator-2.png" alt="Creator" />
              <img src="/assets/creators/creator-3.png" alt="Creator" />
              <img src="/assets/creators/creator-4.png" alt="Creator" />
              <span className="avatar-count">1K+</span>
            </div>

            <p>
              <strong>1,000+ creators.</strong>
              <br />
              Endless stories. One Bahamian community.
            </p>
          </div>
        </div>

        <div className="hero-visual">
          <img src="/assets/hero-phones.png" alt="Rebel app shown on two mobile phones" />
        </div>
      </section>

      <section className="section trending" id="trending">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Start watching now</p>
            <h2>Trending on Rebel</h2>
          </div>
          <Link className="text-link" to="/home">
            Browse all →
          </Link>
        </div>

        {/* <div className="video-grid">
          {!topPostVideos || topPostVideos.loading ? (
            <div className="text-white">Loading...</div>
          ) : topPostVideos.data && topPostVideos.data.length ? (
            topPostVideos.data.slice(0, 6).map((list, i) => (
              <article className="video-card" key={i}>
                <a href={`/share/share.php?id=${list.post_unique_id}`} target="_blank" rel="noopener noreferrer">
                  <img
                    src={
                      list.preview_pic && list.preview_pic !== ""
                        ? `${api.serviceUrl()}/${list.preview_pic}`
                        : "/assets/images/upload-profile-img.svg"
                    }
                    alt={list.short_content}
                  />
                  <span className={`category ${colors[i % colors.length]}`}>
                    {list.category || "Video"}
                  </span>
                  <div className="video-overlay">
                    <h3>{list.user_name}</h3>
                    <p>{list.short_content}</p>
                    <span className="duration">{list.video_duration || "00:00"}</span>
                  </div>
                </a>
              </article>
            ))
          ) : (
            <div className="text-muted">No videos found.</div>
          )}
        </div> */}
        <div class="video-grid">
          <article class="video-card">
            <a href="https://rebeltv.me/share/share.php?id=PF-486-69b6e38b28647">
              <img src="assets/card-documentary.jpg" alt="" />
                <span class="category violet">Documentary</span>
                <div class="video-overlay">
                  <h3>Fresh Grooves</h3>
                  <p>Rockumentary Part 1</p>
                  <span class="duration">47:10</span>
                </div>
            </a>
          </article>

          <article class="video-card">
            <a href="https://rebeltv.me/share/share.php?id=PF-506-6a3bf8825ce78">
              <img src="assets/card-sports.jpg" alt="" />
                <span class="category green">Sports</span>
                <div class="video-overlay">
                  <h3>Shaunae Miller</h3>
                  <p>Was it a Stumble or Dive</p>
                  <span class="duration">03:30</span>
                </div>
            </a>
          </article>

          <article class="video-card">
            <img src="assets/card-music.jpg" alt="" />
              <span class="category pink">Music</span>
              <div class="video-overlay">
                <h3>The Spin</h3>
                <p>With DJ AI & Guest</p>
                <span class="duration">15:00</span>
              </div>
          </article>

          <article class="video-card">
            <img src="assets/card-podcast.jpg" alt="" />
              <span class="category blue">Podcast</span>
              <div class="video-overlay">
                <h3>With Lisa G</h3>
                <p>Real Conversations</p>
                <span class="duration">42:18</span>
              </div>
          </article>

          <article class="video-card">
            <img src="assets/card-comedy.jpg" alt="" />
              <span class="category orange">Comedy</span>
              <div class="video-overlay">
                <h3>Island Laughs</h3>
                <p>Clean Comedy</p>
                <span class="duration">12:09</span>
              </div>
          </article>

          <article class="video-card">
            <img src="assets/card-food.jpg" alt="" />
              <span class="category gold">Food</span>
              <div class="video-overlay">
                <h3>Bahamian Bites</h3>
                <p>Island Flavors</p>
                <span class="duration">08:30</span>
              </div>
          </article>
        </div>
      </section>

      <section className="section watch-benefits" id="how">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Made for viewers</p>
            <h2>Why Watch Rebel?</h2>
          </div>
        </div>

        <div className="benefit-grid">
          <article className="benefit-item">
            <span className="feature-icon">▣</span>
            <div>
              <h3>Exclusive Content</h3>
              <p>Original shows, local stories and premium content you will not find anywhere else.</p>
            </div>
          </article>
          <article className="benefit-item">
            <span className="feature-icon">♡</span>
            <div>
              <h3>Support Local</h3>
              <p>Every view, like and share helps Bahamian creators grow and earn.</p>
            </div>
          </article>
          <article className="benefit-item">
            <span className="feature-icon">▤</span>
            <div>
              <h3>Watch Anywhere</h3>
              <p>Stream on your phone, tablet, laptop or TV anytime.</p>
            </div>
          </article>
          <article className="benefit-item">
            <span className="feature-icon">♕</span>
            <div>
              <h3>Premium Access</h3>
              <p>Unlock exclusive releases, early access and ad-free viewing.</p>
            </div>
          </article>
          <article className="benefit-item">
            <span className="feature-icon">ϟ</span>
            <div>
              <h3>New Daily</h3>
              <p>Fresh videos, new creators and trending content added every day.</p>
            </div>
          </article>
        </div>
      </section>

      <section className="section creator-and-app" id="creators">
        <div className="creator-panel">
          <div className="section-heading compact">
            <div>
              <p className="eyebrow">Build an audience and earn</p>
              <h2>Why Creators Love Rebel</h2>
            </div>
          </div>

          <div className="creator-grid">
            <article>
              <span>$</span>
              <div>
                <h3>Paid Per View</h3>
                <p>Earn when people watch your videos.</p>
              </div>
            </article>
            <article>
              <span>🎁</span>
              <div>
                <h3>Receive Tips</h3>
                <p>Fans can directly support your work.</p>
              </div>
            </article>
            <article>
              <span>♙</span>
              <div>
                <h3>Monthly Subscribers</h3>
                <p>Build a loyal community and recurring income.</p>
              </div>
            </article>
            <article>
              <span>🔒</span>
              <div>
                <h3>Exclusive Content</h3>
                <p>Offer premium posts only your fans can see.</p>
              </div>
            </article>
            <article>
              <span>▥</span>
              <div>
                <h3>Creator Dashboard</h3>
                <p>Track earnings, views and growth.</p>
              </div>
            </article>
          </div>
        </div>

        <aside className="app-panel">
          <div>
            <p className="eyebrow">REBEL MOBILE APP</p>
            <h2>Coming Soon</h2>
            <p>
              Watch. Create. Earn.
              <br />
              All in one app.
            </p>
            <div className="store-buttons">
              <a href="#"> App Store</a>
              <a href="#">▶ Google Play</a>
            </div>
          </div>
          <img src="/assets/rebel-app-phone.png" alt="Rebel mobile app" />
        </aside>
      </section>
    </LandingLayout>
  );
};

export default LandingPage;
